/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectApplicant } from "../../features/applicant/ApplicantSlice";
import { selectConstants } from "./Api/constantSlice";
import { DropdownDto } from "./Api/Models";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
  disableParents: boolean;
}
export default function GuardianTypeOptions({ formik, disableParents }: Props) {
  const selConst = useAppSelector(selectConstants);
  const applicant = useAppSelector(selectApplicant);

  const displayLabel = () => {
    return formik.values.firstName
      ? `What is the relationship of ${formik.values.firstName} ${formik.values.surname} to ${applicant.loginState?.accessToken?.displayName}`
      : `What is the relationship of ${formik.values.name} to ${applicant.loginState?.accessToken?.displayName}`;
  };

  const diableOptions = (guardianTypesOptionsId: number) => {
    if (
      (disableParents && guardianTypesOptionsId === 1011) ||
      (disableParents && guardianTypesOptionsId === 1012)
    ) {
      return true;
    }
    if (
      (formik.values.guardianTypeId === 1 && guardianTypesOptionsId === 1011) ||
      (formik.values.guardianTypeId === 1 && guardianTypesOptionsId === 1012)
    ) {
      return true;
    }

    if (formik.values.guardianTypeId === 8) {
      if (
        guardianTypesOptionsId === 1110 ||
        guardianTypesOptionsId === 1091 ||
        guardianTypesOptionsId === 1081 ||
        guardianTypesOptionsId === 1071 ||
        guardianTypesOptionsId === 1061 ||
        guardianTypesOptionsId === 1041 ||
        guardianTypesOptionsId === 1031 ||
        guardianTypesOptionsId === 1051
      )
        return true;
    }

    return false;
  };
  return (
    <>
      {selConst.constantState.guardianTypesOptions && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.guardianTypeOptionId &&
                Boolean(formik.errors.guardianTypeOptionId)
              }
              id="demo-select-small"
            >
              {displayLabel()}
            </InputLabel>
            <Select
              required
              name="guardianTypeOptionId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.guardianTypeOptionId}
              label={displayLabel()}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.guardianTypeOptionId &&
                Boolean(formik.errors.guardianTypeOptionId)
              }
            >
              <MenuItem value={0} disabled>
                {displayLabel()}
              </MenuItem>
              {selConst.constantState.guardianTypesOptions.map(
                (data: DropdownDto, key: number) => {
                  return (
                    <MenuItem
                      key={key}
                      value={data.id}
                      disabled={diableOptions(data.id)}
                    >
                      {data.description}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>
          <ErrorBox>
            {formik.touched.guardianTypeOptionId &&
              (formik.errors.guardianTypeOptionId as React.ReactNode)}
          </ErrorBox>
        </>
      )}
    </>
  );
}
